var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      ref: "formItem",
      style: _vm.$attrs["style"],
      attrs: {
        "label-width": _vm.$attrs["label-width"],
        prop: _vm.$attrs["prop"],
        label: _vm.$attrs["label"],
      },
    },
    [
      _c(
        "el-input",
        _vm._b(
          {
            attrs: { type: "textarea", autocomplete: "off" },
            on: {
              input: function (value) {
                return _vm.setModel(value)
              },
            },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          },
          "el-input",
          _vm.$attrs,
          false
        ),
        [
          _vm.$slots.append
            ? _c(
                "template",
                { slot: "append" },
                _vm._l(_vm.$slots.append, function (item) {
                  return _c("span", { key: item.text }, [
                    _vm._v(" " + _vm._s(item.text) + " "),
                  ])
                }),
                0
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }